export default function PaymentDisabledModal() {
  return <div>Payment is disabled for this channel</div>;
}
